// extracted by mini-css-extract-plugin
export default {"wrapper":"_2KwvD","skeleton-progress":"ajMl3"};